RivalIQ.module('state', function (state, App, Backbone, Marionette, $, _) {

    'use strict';

    state.plan = new Backbone.Model();

    state.plan.initialize = function (properties) {
        const me = this;
        me.set(properties.plan, {
            silent: true
        });
    };
});
